module.exports = "data:image/svg+xml;base64,PHN2Zz4KICA8ZGVmcz4KICAgIDxzeW1ib2wgaWQ9InJvdW5kZWQtcmVjdGFuZ2xlIiBvdmVyZmxvdz0idmlzaWJsZSIKCQlwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCI+Cgk8ZGVzYz5yb3VuZGVkLXJlY3RhbmdsZTwvZGVzYz4KCTxyZWN0IHN0cm9rZT0iY3VycmVudENvbG9yIiB4PSIwIiB5PSIwIiByeD0iMTUiIHJ5PSIxNSIKCQl3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCI+PC9yZWN0PgogICAgPC9zeW1ib2w+CiAgPC9kZWZzPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/icons/rounded-rectangle.svg
// module id = 708
// module chunks = 0